import { IProductOwner } from "@nkr/models/index";

export interface ISummary {
    total: number,
    percent: number,
    average?: number
}

export interface ISaturationSummaryProductOwner {
    isProductOwner: true,
    isMemberCenter: IProductOwner,
    isRemoteDonationCenter: IProductOwner,
    allInAddendumSigned: IProductOwner,
    allInBestGuess: IProductOwner,
    partnerCenter: IProductOwner,
    screeningVirtualCrossMatchUser: IProductOwner,
    donorProtectionAddendumSigned: IProductOwner,
    vem: IProductOwner,

    voucherProgramActive: IProductOwner,
    voucherProgramUtilization: IProductOwner,

    donorShieldDirectUser: IProductOwner,
    donorShieldDirectFullyUtilized: IProductOwner,
    dsdUtilization: IProductOwner,

    dashActive: IProductOwner,
    dashFullyUtilized: IProductOwner,
    dashUtilization: IProductOwner,

    donorShieldDirectLiverParticipant: IProductOwner,
    liverDashActive: IProductOwner,

    pwlActive: IProductOwner,
    pwlFullyUtilized: IProductOwner,
    pwlUtilization: IProductOwner,

    automatedDonorFollowUpActive: IProductOwner,
    automatedDonorFollowUpFullyUtilized: IProductOwner,
    automatedDonorFollowUpUtilization: IProductOwner,

    micrositesActive: IProductOwner,
    micrositesFullyUtilized: IProductOwner,
    micrositeUtilization: IProductOwner,
    micrositeCount: IProductOwner,
    micrositeActiveStarterSiteCount: IProductOwner,
    micrositeActiveCustomSiteCount: IProductOwner,
    micrositesLdtxpL12: IProductOwner,

    completedMoreThan0PatientTrainingSessions: IProductOwner,
    completedMoreThan2PatientTrainingSessions: IProductOwner,
    isAcceptingPatientReferralsForMicrosites: IProductOwner,
    acceptingDonorReferrals: IProductOwner,
    acceptingPatientReferrals: IProductOwner,
    acceptingKfLPatientReferrals: IProductOwner,

    optInAutomatedSerologies: IProductOwner,
    includedInCenterListingService: IProductOwner,

    donorReferralCount: IProductOwner,
    patientsWithLivingDonorReferralCount: IProductOwner,
    patientsDesiringMicrositeReferralCount: IProductOwner,
    patientsDesiringKflReferralCount: IProductOwner,
    patientsTotalCount: IProductOwner,

    automatedCollectionsAndClearing: IProductOwner,
    automatedCollectionsAndClearingInvoiceCount: IProductOwner,
    shbEligibleSwaps: IProductOwner,
    shbUtilized: IProductOwner,
    shbFullyUtilized: IProductOwner,
    ubpInvTrigCount: IProductOwner,
    streamlinedBillingService: IProductOwner,

    billable: IProductOwner,
    donorCareNetworkCenter: IProductOwner,
    offerDonorConnect: IProductOwner,
    goldStarCenter: IProductOwner,

    xpLast12Months: IProductOwner,

    kidneyForLifeActive: IProductOwner,
    kidneyForLifeFullyUtilized: IProductOwner,
    kidneyForLifeUtilization: IProductOwner,
    kidneyForLifeSuccess: IProductOwner,
    lowExpletTxpCountL12M: IProductOwner,

    directStreamlinedSerologyCount: IProductOwner,
    homeBloodDrawCount: IProductOwner,

    saturationTotal: IProductOwner,
    saturationAnnualGoal: IProductOwner,
    saturationVariance: IProductOwner,
    isExpertSystem: IProductOwner,
    expertSystemFullyUtilized: IProductOwner
}

export interface ISaturationSummary {
    isSummary: true,
    isMemberCenter: ISummary,
    isRemoteDonationCenter: ISummary,
    allInAddendumSigned: ISummary,
    allInBestGuess: ISummary,
    partnerCenter: ISummary,
    screeningVirtualCrossMatchUser: ISummary,
    donorProtectionAddendumSigned: ISummary,
    vem: ISummary,

    voucherProgramActive: ISummary,
    voucherProgramUtilization: ISummary,

    donorShieldDirectUser: ISummary,
    donorShieldDirectFullyUtilized: ISummary,
    dsdUtilization: ISummary,

    donorShieldDirectLiverParticipant: ISummary,
    dashActive: ISummary,
    dashFullyUtilized: ISummary,
    dashUtilization: ISummary,

    liverDashActive: ISummary,

    pwlActive: ISummary,
    pwlFullyUtilized: ISummary,
    pwlUtilization: ISummary,

    automatedDonorFollowUpActive: ISummary,
    automatedDonorFollowUpFullyUtilized: ISummary,
    automatedDonorFollowUpUtilization: ISummary,

    micrositesActive: ISummary,
    micrositesFullyUtilized: ISummary,
    micrositeUtilization: ISummary,
    micrositeCount: ISummary,
    micrositeActiveStarterSiteCount: ISummary,
    micrositeActiveCustomSiteCount: ISummary,
    micrositesLdtxpL12: ISummary,

    isAcceptingPatientReferralsForMicrosites: ISummary,
    completedMoreThan0PatientTrainingSessions: ISummary,
    completedMoreThan2PatientTrainingSessions: ISummary,
    acceptingDonorReferrals: ISummary,
    acceptingPatientReferrals: ISummary,
    optInAutomatedSerologies: ISummary,
    includedInCenterListingService: ISummary,

    donorReferralCount: ISummary,
    patientsWithLivingDonorReferralCount: ISummary,
    patientsDesiringMicrositeReferralCount: ISummary,
    acceptingKflPatientReferrals: ISummary,
    patientsDesiringKflReferralCount: ISummary,
    patientsTotalCount: ISummary,

    automatedCollectionsAndClearing: ISummary,
    automatedCollectionsAndClearingInvoiceCount: ISummary,
    shbEligibleSwaps: ISummary,
    shbUtilized: ISummary,
    shbFullyUtilized: ISummary,
    ubpInvTrigCount: ISummary,
    streamlinedBillingService: ISummary,

    billable: ISummary,
    donorCareNetworkCenter: ISummary,
    offerDonorConnect: ISummary,
    goldStarCenter: ISummary,

    xpLast12Months: ISummary,

    kidneyForLifeActive: ISummary,
    kidneyForLifeFullyUtilized: ISummary,
    kidneyForLifeUtilization: ISummary,
    kidneyForLifeSuccess: ISummary,
    lowExpletTxpCountL12M: ISummary,

    directStreamlinedSerologyCount: ISummary,
    homeBloodDrawCount: ISummary,

    saturationTotal: ISummary,
    saturationAnnualGoal: ISummary,
    saturationVariance: ISummary,
    isExpertSystem: ISummary,
    expertSystemFullyUtilized: ISummary
}
